module.exports = "<p>{{ message }}</p>\n<hkt-adminloginform (loggedIn)=\"loggedIn.emit()\"></hkt-adminloginform>\n"